export var AdType;
(function (AdType) {
    AdType["PREROLL"] = "preroll";
    AdType["MIDROLL"] = "midroll";
})(AdType || (AdType = {}));
